import React, { useEffect, useState } from "react";
import "./document.css";
import apiService from '../../../services/apiService';
import Loader from '../../layouts/loader';
import CustomToast from '../../Toast';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Document = ({moduleContent, updateLmsModule}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [loader, setLoader] = useState(false);
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentLang = localStorage.getItem('userLang')

  console.log("moduleContent", currentLang)

  //  {console.log("moduleContents", moduleContent?.moduleContent?.document)}

   const getLangCode = (lang) => {
    switch (lang) {
      case 'English':
        return 'en'; 
      case 'Hindi':
        return 'hi';
      case 'Marathi':
        return 'mar';
      default:
        return 'en';
    }
  };

  const langId = getLangCode(currentLang);
  const tForLang = i18n.getFixedT(langId);

   const handleMarkAsCompleted = async (data) => {

    updateLmsModule().then((data) => {

    });

    setCompleted(true);
  };

  return (
    <>
    <div className="document-page">
        <div className="text-center my-4"><div dangerouslySetInnerHTML={{ __html: moduleContent?.content }} /></div>
        <div className="pdf-container">
          {moduleContent?.moduleContent?.document ? (() => {
            const url = moduleContent?.moduleContent?.document;
            const ext = url.split('.').pop().toLowerCase();

            let embedUrl = '';

            if (ext === 'pdf') {
              embedUrl = moduleContent?.moduleContent?.downloadable ? url : `${url}#toolbar=0`;
            } else if (['doc', 'docx', 'xls', 'xlsx'].includes(ext)) {
              embedUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
            } else {
              return <p>Unsupported file format.</p>;
            }

            return (
              <iframe
                src={embedUrl}
                className="pdf-iframe"
                title="PDF Viewer"
                frameBorder="0"
                width="100%"
                height="600px"
                toolbar="0"
              />
            );
          })() : (
            <p>No document available.</p>
          )}

        </div>
      </div>
      <p className='text-end mt-4 pt-3 mb-0 border-top'>
        {moduleContent?.moduleContent?.downloadable && (
          <a className="btn btn-md btn-primary rounded-pill me-2" download target="_blank" href={moduleContent?.moduleContent?.document}>
             {tForLang('course_modules_doc_download')}
          </a>
        )}
        {!moduleContent?.moduleContent?.is_completed && (
          <button onClick={handleMarkAsCompleted} className='btn btn-md btn-primary rounded-pill mt-1'>{tForLang('course_modules_next')}</button>
        )}
          {moduleContent?.moduleContent?.is_completed && (
          <button onClick={handleMarkAsCompleted} className='btn btn-md btn-primary rounded-pill mt-1'>{tForLang('course_modules_next')}</button>
        )}
      </p>
      </>
  );
};

export default Document;